module.exports = __webpack_public_path__ + "dc9afb09e3f637d17da0b30e72646e5a.svg";